import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Badge, Button, IconButton, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import { useState } from 'react';
import DateField from '../../../components/UI/DateField';

const initFilter = {
  status: '',
  startDateFrom: '',
  startDateTo: '',
  createdAtFrom: '',
  createdAtTo: '',
};

const FilterMenu = ({ onFilterReset, filterState, onFilterApply }) => {
  const [filterStateLocal, setFilterStateLocal] = useState({ ...initFilter });

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setFilterStateLocal(filterState);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setFilterStateLocal({ ...initFilter });
  };

  const handleFilterApply = () => {
    onFilterApply(filterStateLocal);
    handleClose();
  };

  const isThisResetState =
    filterState?.status !== '' ||
    filterState?.startDateFrom !== '' ||
    filterState?.startDateTo !== '' ||
    filterState?.createdAtFrom !== '' ||
    filterState?.createdAtTo !== '';

  const handleFilterReset = () => {
    isThisResetState && onFilterReset();
    setFilterStateLocal(initFilter);
    handleClose();
  };

  return (
    <div>
      <Tooltip title="Filter">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            // ml: 2,
            height: '40px',
            width: '40px',
            backgroundColor: '#027c34',
            '&:hover': { backgroundColor: '#027d35' },
          }}
        >
          <Badge color="error" variant="dot" invisible={!isThisResetState}>
            <FilterAltIcon sx={{ color: 'white' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            width: '300px',
            padding: '0px 8px',
          },
        }}
      >
        <h2>Filter</h2>
        <TextField
          value={filterStateLocal?.status}
          onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, status: e.target.value }))}
          sx={{
            my: '8px',
          }}
          select
          label="Status"
          size="small"
          fullWidth
          variant="outlined"
        >
          <MenuItem value="PUBLISHED">Published</MenuItem>
          <MenuItem value="INACTIVE">Inactive</MenuItem>
          <MenuItem value="SCHEDULED">Scheduled</MenuItem>
        </TextField>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '8px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Created date
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <DateField
              value={filterStateLocal.startDateFrom}
              fullWidth
              variant="outlined"
              label="From"
              onChange={(e) =>
                setFilterStateLocal((prev) => ({ ...prev, startDateFrom: e?.isValid() ? e.toISOString() : '' }))
              }
            />
            <DateField
              value={filterStateLocal.startDateTo}
              fullWidth
              variant="outlined"
              label="To"
              onChange={(e) =>
                setFilterStateLocal((prev) => ({ ...prev, startDateTo: e?.isValid() ? e.toISOString() : '' }))
              }
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '8px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Published date
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <DateField
              value={filterStateLocal.createdAtFrom}
              fullWidth
              variant="outlined"
              label="From"
              onChange={(e) =>
                setFilterStateLocal((prev) => ({ ...prev, createdAtFrom: e?.isValid() ? e.toISOString() : '' }))
              }
            />
            <DateField
              value={filterStateLocal.createdAtTo}
              fullWidth
              variant="outlined"
              label="To"
              onChange={(e) =>
                setFilterStateLocal((prev) => ({ ...prev, createdAtTo: e?.isValid() ? e.toISOString() : '' }))
              }
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
          <Button
            sx={{
              textTransform: 'capitalize',
              backgroundColor: '#ff4842',
              color: 'white',
              borderRadius: '30px',
              ':hover': { backgroundColor: '#d40700' },
            }}
            onClick={handleClose}
            size="small"
            variant="contained"
          >
            Close
          </Button>
          <Button
            sx={{
              textTransform: 'capitalize',
              borderRadius: '30px',
              backgroundColor: '#027c34',
              '&:hover': { backgroundColor: '#027d35' },
            }}
            onClick={handleFilterReset}
            size="small"
            variant="contained"
          >
            Reset
          </Button>
          <Button
            sx={{
              textTransform: 'capitalize',
              borderRadius: '30px',
              backgroundColor: '#027c34',
              '&:hover': { backgroundColor: '#027d35' },
            }}
            onClick={handleFilterApply}
            size="small"
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </Menu>
    </div>
  );
};

export default FilterMenu;
